export default __webpack_public_path__ + "static/media/GraphicSVG.834bf197.png";